// extracted by mini-css-extract-plugin
module.exports = {"modal_button":"DefaultLanguageHelp_modal_button__1C2dE","help_component":"DefaultLanguageHelp_help_component__1wp0y"};